module.exports = __webpack_public_path__ + "static/UnclickMedicalTravelYellow-d6311b14d51fb238b0de829cd35f9e4b.png";